var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
  'app--open-menu': this.$menu.current === 'is-open',
},attrs:{"id":"app"}},[(this.$menu.current === 'is-open' && this.$layout.current === 'phone')?_c('div',{staticClass:"app__mask",on:{"click":_vm.closeMenu}}):_vm._e(),_c('div',{staticClass:"app__mask-open-item"}),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }